//
//
//
//
//
//

import storage from "./common/storage.js";
export default {
    data() {
        return {
            flag: false
        };
    },
    methods: {
        getVersion() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isIE =
                userAgent.indexOf("compatible") > -1 &&
                userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion == 7) {
                    return 7;
                } else if (fIEVersion == 8) {
                    return 8;
                } else if (fIEVersion == 9) {
                    return 9;
                } else if (fIEVersion == 10) {
                    return 10;
                } else {
                    return 6; //IE版本<=7
                }
            }
        }
    },
    mounted() {
        let flag = this.getVersion();
        if (flag < 11) {
            this.flag = true;
        }
    }
};



// WEBPACK FOOTER //
// ./src/App.vue